<template>
  <section class="result">
    <div class="result-content section-block unit">

      <div class="result-type">
        <p class="result-type__caption">{{ yourType[0] }}</p>
        <p class="result-type__head">{{ yourType[1] }}</p>
      </div>

      <div class="result-detail">
        <div class="result-chart">
          <!-- 最高は60点／最低は5点 -->
          <BarChart :chart-data="chartdata" :options="options" :height="height"></BarChart>
          <img src="/diagnosis/common/img/result_town.png" alt="" width="270" height="261" class="result-chart__town">

          <Accordion classText="define">
            <template v-slot:courseName>グラフの詳しい説明はこちら</template>
            <template v-slot:courseBody>
              <dl class="define__list">
                <dt class="define__item define__item--1">外向性</dt><dd class="define__exp">コミュニケーション上手で、何事にも積極的に取り組む</dd>
                <dt class="define__item define__item--2">自律性</dt><dd class="define__exp">自分自身に厳しく、着実に目標を達成することができる</dd>
                <dt class="define__item define__item--3">創造性</dt><dd class="define__exp">型にはまらない発想力でこれまでにないものを生み出す</dd>
                <dt class="define__item define__item--4">調和性</dt><dd class="define__exp">常に思いやりをもって周囲に接し、協調したいと考える</dd>
                <dt class="define__item define__item--5">没入性</dt><dd class="define__exp">何に対しても、集中して根気よく取り組むことができる</dd>
                <dt class="define__item define__item--6">論理性</dt><dd class="define__exp u-letter-s">客観的に現実を見つめ、その場に応じたベストな選択ができる</dd>
              </dl>
            </template>
          </Accordion>
        </div>

        <div class="result-description">
          <p class="result-description__text">{{ yourType[2] }}</p>
          <div>
            <p class="result-description__advice-title"><img src="/diagnosis/common/img/icon_book.svg" alt="">学びアドバイス</p>
            <p class="result-description__advice-text">{{ yourType[3] }}</p>
          </div>
        </div>
      </div>
    </div>

    <section class="acd section-block unit">
      <img src="/diagnosis/common/img/fukidashi.png" alt="オススメ！" width="181" height="88" class="acd__fukidashi">
      <h2 class="acd-title">あなたにオススメの資格講座</h2>
      <Accordion v-for="(course, index) in shikakuData1" :key="index" :classText="`${course.id}`">
        <template v-slot:courseName>{{ course.course_name }}<a :href="`/course/data/in_html/${course.sequence}/?il=from_diagnosis_result_${recomCourse}`" :target="target" :rel="rel" class="acd-course__link"></a></template>
        <template v-slot:courseBody>
          <div class="acd-body__flex">
            <p class="acd-body__img"><img v-bind:src="`/course/recommend/img/${course.sequence}.png`" width="140" height="140" alt=""></p>
            <!-- <p class="acd-body__img"><img :src="`/diagnosis/img/${course.sequence}.png`" width="140" height="140" alt=""></p> 開発用-->
            <ul class="acd-body__list">
              <li class="acd-body__item">{{ course.text1 }}</li>
              <li class="acd-body__item" v-if="course.text2 != ''">{{ course.text2 }}</li>
            </ul>
          </div>
          <p class="acd-body__link"><a :href="`/course/data/in_html/${course.sequence}/?il=from_diagnosis_result_${recomCourse}`" :target="target" :rel="rel">詳しくはこちら &gt;</a></p>
        </template>
      </Accordion>
    </section>

    <div class="others-wrap unit section-block">
      <section class="others">
        <h3 class="others__title">こちらもあなたにオススメ！</h3>
        <p class="others__lead">このタイプの人には、他にもこんな講座がオススメです。<br class="is-pc">あなたの "何か始めたい"、"何か見つけたい" にピッタリの講座が見つかるかも!</p>

        <div class="others-body__flex">
          <div class="others-sub others-box--shikaku2">
            <h4 class="others-sub__title">あなたにオススメ！ 資格講座</h4>
            <ul class="others-sub__list">
              <li v-for="(course, index) in shikakuData2" :key="index" :classText="`${course.id}`" class="others-sub__item">
                <a :href="`/course/data/in_html/${course.sequence}/?il=from_diagnosis_result_${recomCourse}`" :target="target" :rel="rel" class="others-sub__link u-arrow"> {{ course.course_name }}</a>
              </li>
            </ul>
          </div>

          <div class="others-sub others-box--syumi">
            <div class="others-box--syumi1">
              <h4 class="others-sub__title">楽しむなら！ 趣味・実用講座</h4>
              <ul class="others-sub__list">
                <li v-for="(course, index) in syumiData1" :key="index" :classText="`${course.id}`" class="others-sub__item">
                  <a :href="`/course/data/in_html/${course.sequence}/?il=from_diagnosis_result_${recomCourse}`"  :target="target" :rel="rel" class="others-sub__link u-arrow"> {{ course.course_name }}</a>
                </li>
              </ul>
            </div>

            <div class="others-box--syumi2">
              <Accordion classText="more">
                <template v-slot:courseName>もっと見る</template>
                <template v-slot:courseBody>
                  <ul>
                    <li v-for="(course, index) in syumiData2" :key="index" :classText="`${course.id}`" class="others-sub__item">
                    <a :href="`/course/data/in_html/${course.sequence}/?il=from_diagnosis_result_${recomCourse}`" :target="target" :rel="rel" class="others-sub__link u-arrow"> {{ course.course_name }}</a>
                    </li>
                  </ul>
                </template>
              </Accordion>
            </div>
          </div>
        </div>

      </section>
    </div>

    <div class="section-block unit result-note">
      <p class="u-small-text result-note__text">TOEICはETSの登録商標です。この製品はETSの検討を受けまたはその承認を得たものではありません。<br class="is-pc--large">L&RはLISTENING AND READINGを意味しています。</p>
      <p class="result-note__link"><a href="/course/">全講座一覧を見る &gt;</a></p>
    </div>

    <p class="section-block"><button class="restart-btn" @click="onClick">最初からやり直す</button></p>
    <Pagetop></Pagetop>
  </section>
</template>


<script>
import axios from 'axios'
import BarChart from './BarChart'
import Accordion from './Accordion'
import Pagetop from './Pagetop'

const ua = navigator.userAgent.toLowerCase()
let device = 'sp'

export default {
  name: 'Result',

  components: {
    BarChart: BarChart,
    Accordion: Accordion,
    Pagetop: Pagetop
  },

  props: {
    propertyAll: Object,
    yourType: Array,
    recomCourse: String
  },

  data: () => {
    return {
      courseData: {},
      shikakuData1: {},
      shikakuData2: {},
      syumiData1: {},
      syumiData2: {},

      chartdata: {label:[], datasets:[]},
      options: {responsive:false, maintainAspectRatio:false, scales:{}, legend:{}},

      height: 180,

      target: '_self',
      rel: ''
    };
  },

  created: function() {

    if(ua.indexOf('iphone') >= 0 || ua.indexOf('ipod') >= 0 || ua.indexOf('android') >= 0 && ua.indexOf('mobile') >= 0){
      device == 'sp'
    }else{
      device == 'pc'
      this.target = '_blank'
      this.rel = 'noopener noreferrer'
    }

    // console.log('===this.recomCourse===')
    // console.log(this.recomCourse)

    let courseFile = this.recomCourse.slice(-2)
    this.fetchRecom(`/diagnosis/common/recom/${courseFile}.json`)
    // this.fetchRecom(`../../diagnosis/recom/${courseFile}.json`) 開発用
  },

  mounted: function() {
    this.fillData()
  },

  computed: {
    propertyAllTemp: function(){
      return JSON.parse(JSON.stringify(this.propertyAll))
    },
  },

  methods: {
    fetchRecom: function(path) {
      axios.get(path).then(response => {
        // console.log('==response.data==');
        // console.log(response.data);

        this.courseData = response.data
        this.shikakuData1 = this.courseData.filter((course) => {
          return (course.course_type == 'shikaku1')
        })
        this.shikakuData2 = this.courseData.filter((course) => {
          return (course.course_type == 'shikaku2')
        })
        this.syumiData1 = this.courseData.filter((course) => {
          return (course.course_type == 'syumi1')
        })
        this.syumiData2 = this.courseData.filter((course) => {
          return (course.course_type == 'syumi2')
        })
      })
      .catch(function (error) {
        console.log(error);
      });
    },

    onClick: function() {
      this.$emit('click-restart')
    },

    fillData () {
      this.chartdata = {
        labels: ['外向性', '自律性', '創造性', '調和性', '没入性', '論理性'],
        datasets: [
          {
            backgroundColor: ["#e58728", "#66b3ec", "#57b349", "#ec786b", "#dace41", "#2c649a"],
            data: [this.propertyAllTemp.extra, this.propertyAllTemp.self, this.propertyAllTemp.creative, this.propertyAllTemp.harmony, this.propertyAllTemp.devote, this.propertyAllTemp.logic]
          }
        ]
      }

      this.options = {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: false
        },
        scales: {
          xAxes: [{
            display: false,
            ticks: {
                min: 0,
                max: 60
            },
            gridLines: {
              display:false
            }
          }],

          yAxes: [{
            datasets: { bar: { barPercentage: 0.6 } },
            gridLines: {
              display:false
            },
            ticks: {
                fontSize: 16
            },
          }]
        },
        legend: {
          display: false
        }
      }
    }
  }
}
</script>


<style scoped>
</style>